import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';

export const StyledCircularProgress = styled(CircularProgress)`
  circle {
    stroke: url(#standard-circular-gradient);
  }
`;

export const ProgressBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
  height: 540px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 375px;
    width: 100%;
  };
`;
